// These are currently provision via ember_app/app/styles/fonts.sass

// Note: "Roboto" font is legacy now, we should replace it with "Graphik Web" where possible.
export const FONT_FAMILY_ROBOTO = "Roboto";

// Use for higher-level headings and titles. E.g page titles, team titles.
// Always used with uppercase text (text-transform: uppercase).
// Note: "League Gothic" font is legacy now, we should replace it with Knockout where possible.
export const FONT_FAMILY_LEAGUE_GOTHIC = "'League Gothic Variable', sans-serif";
export const FONT_FAMILY_KNOCKOUT = "'Knockout', sans-serif";
export const FONT_FAMILY_KNOCKOUT_JUNIOR = "'Knockout Junior', sans-serif";

// Less bold Gothic font. Used for lower-level or functional headings.
// Note: "Pathway Gothic One" font is legacy now, we should replace it with Knockout where possible.
export const FONT_FAMILY_PATHWAY_GOTHIC_ONE = "'Pathway Gothic One', sans-serif";

// "Graphik Web" font is Glory League purchased custom font.
// Used for body text and some headings.
export const FONT_FAMILY_GRAPHIK = "'Graphik Web', sans-serif";

// HTF-30-JuniorWelterwt
export const TEXT_STYLE_TEAM_NAME = {
  fontFamily: FONT_FAMILY_KNOCKOUT,
  textTransform: "uppercase",
};

export const TEXT_STYLE_EVENT_SHORT_NAME = {
  fontFamily: FONT_FAMILY_GRAPHIK,
  textTransform: "uppercase",
};
